function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { combineLatest, concat, from as rxFrom, of as rxOf } from 'rxjs';
import { debounceTime, switchMap, map as rxMap } from 'rxjs/operators';
import { isContainer, ItemType, LoadingState, Page, TreeNode, TreeRoot, View, keyToString } from '../models';
import { arrayMerge, arrayPartition } from '../common/array-util';
import Maybe from '../common/maybe';
import maybeSwitchMap from '../common/maybe-rx-map';
import { isContainerKey } from '../models/container-key';
import { firstGroupBy, secondGroupBy } from '../models/project-grouping';
import { isSubRoot, subRootId, subRootKey } from '../models/root-folder';
import { getGroupId, stringToGroupId, NO_GROUP, isGroup, groupingToContainer, nextGrouping, isVirtualFolder, extractClient, keyToGrouping, groupingToKey } from '../services/project-grouping';
import StoreService from './store-service';
import { defaultFilter, itemFilter } from '../services/item-list-filter';
import { has as hasIAC } from '@onviobr/services/access';

/**
 * When observing the tree, it should not emit new values more than once within this time (in ms)
 */
var observeTreeEmitDebounce = 100;

/**
 * We will avoid updating the same container's children less than 5 seconds apart
 */
var containerChildrenUpdateDebounce = 5 * 1000;
var defaultPageSize = 100;
var updateChildrenOptionsDefaults = {
  includeFiles: true,
  forceUpdate: false
};
function rxArrayConcat(concatWith) {
  return function (source) {
    return source.pipe(rxMap(function (a) {
      return a.concat(concatWith);
    }));
  };
}
var TreeStore = /*#__PURE__*/function (_StoreService) {
  function TreeStore(stores, treeService, containerService, clientService) {
    var _this;
    _classCallCheck(this, TreeStore);
    _this = _callSuper(this, TreeStore, [stores]);
    _this.treeService = treeService;
    _this.containerService = containerService;
    _this.clientService = clientService;
    _this.hasIAC = hasIAC;
    _this.enableChildCalls = false;
    _this.rootFoldersPromise = void 0;
    /**
     * Tracks the calls to /children that are currently in-flight to avoid duplicates.
     * Key is a string of \<container id\>|\<'all' or 'folders'\>
     * Update requests including children are tracked separately from those not including children
     *
     * Value is a promise which resolves when the update is complete
     */
    _this.updateChildrenInProgress = new Map();
    return _this;
  }
  _inherits(TreeStore, _StoreService);
  return _createClass(TreeStore, [{
    key: "observeRootKey",
    value: function observeRootKey(key) {
      return this.observeAncestry(key).pipe(rxMap(function (ancestors) {
        return ancestors[0];
      }));
    }
  }, {
    key: "observeItemRoot",
    value: function observeItemRoot(key) {
      var _this2 = this;
      return this.observeRootKey(key).pipe(switchMap(function (rootKey) {
        return _this2.stores.items.observe(rootKey);
      }));
    }
  }, {
    key: "getRootFolder",
    value: function () {
      var _getRootFolder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(type) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.rootFoldersPromise) {
                this.rootFoldersPromise = this.getRootFolders();
              }
              _context.next = 3;
              return this.rootFoldersPromise;
            case 3:
              return _context.abrupt("return", _context.sent.get(type));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getRootFolder(_x) {
        return _getRootFolder.apply(this, arguments);
      }
      return getRootFolder;
    }()
    /**
     * Observes the ancestry of the given item. Returns observable of array containing given container's
     * ancestors where the first item in the array is the root (client/my/firm) and the last item is the given key.
     *
     * @param key - the container whose ancestry you want to observe
     * @returns Observable of ancestry array, where [0] = root, [n-1] = key
     * @example observeAncestry(...).pipe(first()).toPromise(); // (to use as a Promise/await-able)
     */
  }, {
    key: "observeAncestry",
    value: function observeAncestry(key, groupBy) {
      var _this3 = this;
      if (isSubRoot(key)) {
        return rxOf([]);
      }
      if (isVirtualFolder(key)) {
        return this.createAncestryOfVirtualFolder(key);
      }
      var parent$ = this.stores.parents.observe(key);
      return parent$.pipe(switchMap(function (parent) {
        if (parent.type === ItemType.Client && isGroup(groupBy)) {
          return _this3.createVirtualAncestry(key, parent, groupBy);
        }
        if (isSubRoot(parent)) {
          return rxOf([key]);
        }
        return _this3.observeAncestry(parent, groupBy).pipe(rxArrayConcat([key]));
      }));
    }
  }, {
    key: "createVirtualAncestry",
    value: function createVirtualAncestry(key, parent, groupBy) {
      var primary = firstGroupBy[groupBy];
      var secondary = secondGroupBy[groupBy];
      var ancestors$ = this.stores.items.observe(key).pipe(rxMap(function (project) {
        var primaryId = getGroupId(primary, project);
        var secondaryId = getGroupId(secondary, project);
        if (primaryId === NO_GROUP) {
          // Case 1 - this project isn't in a group
          return [parent, key];
        }
        if (!secondary || secondaryId === NO_GROUP) {
          var _primaryGrouping = {
            groupBy: primary,
            groupId: primaryId
          };
          var _primaryGroup = groupingToKey(parent, _primaryGrouping);

          // Case two - this project is under one group
          return [parent, _primaryGroup, key];
        }
        var primaryGrouping = {
          groupBy: groupBy,
          groupId: primaryId
        };
        var primaryGroup = groupingToKey(parent, primaryGrouping);
        var secondaryGrouping = {
          groupBy: groupBy,
          groupId: primaryId,
          subGroupId: secondaryId
        };
        var secondaryGroup = groupingToKey(parent, secondaryGrouping);

        // Case 3 - this project is under two groups
        return [parent, primaryGroup, secondaryGroup, key];
      }));
      return ancestors$;
    }
  }, {
    key: "createAncestryOfVirtualFolder",
    value: function createAncestryOfVirtualFolder(key) {
      var client = extractClient(key);
      var grouping = keyToGrouping(key);
      if (grouping.subGroupId) {
        var parentGroup = groupingToKey(client, {
          groupBy: firstGroupBy[grouping.groupBy],
          groupId: grouping === null || grouping === void 0 ? void 0 : grouping.groupId
        });
        return rxOf([client, parentGroup, key]);
      }
      return rxOf([client, key]);
    }

    /**
     * Calls the API to get ancestry for the given container and populates the cache with
     * the containers in the ancestry, plus their relationships in the parents cache.
     *
     * Note: this does not update children cache, and does not cache the Client object
     * but does cache the project -\> client relationship
     *
     * @param key - container whose ancestry should be updated
     * @param getClient - (default false) if true and `key` belongs to a client folder, this will also get update the Client data from core
     * @param companyId -
     */
  }, {
    key: "updateAncestry",
    value: (function () {
      var _updateAncestry = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(key) {
        var getClient,
          companyId,
          path,
          hasProjectRoot,
          fullPath,
          clientId,
          client,
          parentRelations,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              getClient = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
              companyId = _args2.length > 2 ? _args2[2] : undefined;
              _context2.next = 4;
              return this.treeService.getAncestors(key, true);
            case 4:
              path = _context2.sent;
              hasProjectRoot = path[0].type === ItemType.Project;
              fullPath = hasProjectRoot ? [path[0].parent].concat(_toConsumableArray(path)) : path;
              if (!(hasProjectRoot && getClient && companyId && path[0].parent.id !== ItemType.Template)) {
                _context2.next = 13;
                break;
              }
              clientId = path[0].parent.id;
              _context2.next = 11;
              return this.clientService.get(companyId, clientId);
            case 11:
              client = _context2.sent;
              path.unshift(client);
            case 13:
              _context2.next = 15;
              return this.stores.items.putAll(path.map(function (item) {
                return [item, item];
              }));
            case 15:
              parentRelations = fullPath.map(function (item, i) {
                // If this is the first item in the array, then it is the root
                // and its parent is the subRoot. Otherwise it's whatever came before in the array.
                var parentKey = i < 1 ? subRootKey : fullPath[i - 1];
                return [item, parentKey];
              });
              _context2.next = 18;
              return this.stores.parents.putAll(parentRelations);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateAncestry(_x2) {
        return _updateAncestry.apply(this, arguments);
      }
      return updateAncestry;
    }()
    /**
     * Returns an observable of the child keys of the given item key.
     *
     * @param key -
     * @param includeFiles - includes document keys if truthy. Default true
     */
    )
  }, {
    key: "observeChildrenKeys",
    value: function observeChildrenKeys(key) {
      var includeFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var includeFolders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!includeFiles && !includeFolders) {
        throw new Error("Observe children keys called for neither files nor folders (".concat(keyToString(key), ")"));
      }

      // children store has a default value of [], so this will always emit something immediately
      // so as to not hold up combineLatest in `observeTreeRoot`
      return this.stores.children.observe(key).pipe(rxMap(function (keys) {
        return keys.filter(function (childKey) {
          var isCont = isContainerKey(childKey);
          return includeFolders && isCont || includeFiles && !isCont;
        });
      }));
    }

    /**
     * Requests metadata for the children of the given container and updates the cache, notifying all subscribers of the change.
     *
     * @param key -The item whose children should be updated
     * @param optionParams -
     * `includeFiles`: True to include files, false to show only folders. Default true.
     *
     * `forceUpdate`: True to update the children regardless of how recently another update was requested. Default false.
     *
     * `bundleId`: Arbitrary string that tells the queue how these request should be grouped. Defaults to `key.id`
     * @param depth -indicates how far below this folder should be updated. 1 means just this folder's children, 2 means children of this folder's children.
     */
  }, {
    key: "updateChildren",
    value: (function () {
      var _updateChildren2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(key) {
        var _optionParams$bundleI,
          _this4 = this;
        var optionParams,
          depth,
          options,
          inProgressIdentifier,
          inProgressPromise,
          updateChildrenPromise,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              optionParams = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              depth = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 1;
              if (isVirtualFolder(key)) {
                key = extractClient(key);
              }
              options = _objectSpread(_objectSpread(_objectSpread({}, updateChildrenOptionsDefaults), optionParams), {}, {
                bundleId: (_optionParams$bundleI = optionParams.bundleId) !== null && _optionParams$bundleI !== void 0 ? _optionParams$bundleI : key.id
              });
              if (!(depth < 1)) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", []);
            case 6:
              _context3.next = 8;
              return hasIAC('DMS_EnableChildrenCalls').catch(function () {
                return false;
              });
            case 8:
              this.enableChildCalls = _context3.sent;
              if (!this.enableChildCalls && depth > 1) {
                depth = 1;
              }

              // We need to track requests with children and without separately
              // to avoid only updating folders when someone needs files as well.
              // So append an arbitrary string that is somewhat readable for debugging
              inProgressIdentifier = key.id + (options.includeFiles ? '|all' : '|folders');
              inProgressPromise = this.updateChildrenInProgress.get(inProgressIdentifier);
              if (!(!options.forceUpdate && inProgressPromise)) {
                _context3.next = 14;
                break;
              }
              return _context3.abrupt("return", inProgressPromise);
            case 14:
              // _updateChildren does all the actual work - this function just handles debounce/de-duplication
              updateChildrenPromise = this._updateChildren(key, options, depth);
              this.updateChildrenInProgress.set(inProgressIdentifier, updateChildrenPromise);

              // On error, remove the tracking promise so it can be tried again
              void updateChildrenPromise.catch(function () {
                return _this4.updateChildrenInProgress.delete(inProgressIdentifier);
              });

              // After a few seconds, remove the tracking promise
              // Until it is removed, duplicate calls will get the same result.
              setTimeout(function () {
                return _this4.updateChildrenInProgress.delete(inProgressIdentifier);
              }, containerChildrenUpdateDebounce);
              return _context3.abrupt("return", updateChildrenPromise);
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateChildren(_x3) {
        return _updateChildren2.apply(this, arguments);
      }
      return updateChildren;
    }())
  }, {
    key: "updateChildrenPages",
    value: function () {
      var _updateChildrenPages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(children, options, depth) {
        var _this5 = this;
        var folders, _arrayPartition, withChildren, noChildren, childrenPromises;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              folders = children.filter(isContainer);
              _arrayPartition = arrayPartition(folders, function (folder) {
                var hasChildren = folder.hasFolders || options.includeFiles && folder.hasChildren;
                return hasChildren ? 'withChildren' : 'noChildren';
              }), withChildren = _arrayPartition.withChildren, noChildren = _arrayPartition.noChildren;
              noChildren.forEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(folder) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", _this5.setLoadingState(folder, LoadingState.loaded));
                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x7) {
                  return _ref.apply(this, arguments);
                };
              }());
              if (!withChildren.length) {
                _context6.next = 7;
                break;
              }
              childrenPromises = withChildren.map(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(folder) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        return _context5.abrupt("return", _this5.updateChildren(folder, options, depth - 1));
                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x8) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context6.next = 7;
              return Promise.all(childrenPromises);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function updateChildrenPages(_x4, _x5, _x6) {
        return _updateChildrenPages.apply(this, arguments);
      }
      return updateChildrenPages;
    }()
  }, {
    key: "killUpdateQueue",
    value: function killUpdateQueue(bundleId) {
      this.containerService.cancelQueueForBundle(bundleId);
    }
  }, {
    key: "setLoadingState",
    value: function () {
      var _setLoadingState = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(key, newState) {
        var maybeCurrentState;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.stores.containerLoadingState.get(key);
            case 2:
              maybeCurrentState = _context7.sent;
              if (!(maybeCurrentState.isNothing || newState > maybeCurrentState.value)) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return", this.stores.containerLoadingState.put(key, newState));
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setLoadingState(_x9, _x10) {
        return _setLoadingState.apply(this, arguments);
      }
      return setLoadingState;
    }()
  }, {
    key: "observeLoadingState",
    value: function observeLoadingState(key) {
      return this.stores.containerLoadingState.observe(key);
    }
  }, {
    key: "getLoadingState",
    value: function () {
      var _getLoadingState = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(key) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.stores.containerLoadingState.get(key);
            case 2:
              return _context8.abrupt("return", _context8.sent.default(LoadingState.none));
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getLoadingState(_x11) {
        return _getLoadingState.apply(this, arguments);
      }
      return getLoadingState;
    }()
    /**
     * Entry point for tree observation.
     * @param container -
     * @param includeFiles -
     */
  }, {
    key: "observeTree",
    value: function observeTree(container, options) {
      return this.observeTreeRoot(container, defaultFilter(options)).pipe(debounceTime(observeTreeEmitDebounce));
    }

    /**
     * Gets children of `key` and updates the appropriate caches
     * Assumes all debounce and de-duplication is handled.
     *
     * @param key -container whose children to update
     * @param options -
     * @param depth -how far to recurse down the tree
     */
  }, {
    key: "_updateChildren",
    value: (function () {
      var _updateChildren3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(key, options, depth) {
        var children;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return this.updatePages(key, options);
            case 3:
              children = _context9.sent;
              void this.setLoadingState(key, LoadingState.loaded);
              void this.updateChildrenFlags(key, options.includeFiles);

              // Starts recursion to update grandchildren
              _context9.next = 8;
              return this.updateChildrenPages(children, options, depth);
            case 8:
              return _context9.abrupt("return", children);
            case 11:
              _context9.prev = 11;
              _context9.t0 = _context9["catch"](0);
              // Reset the loading state on failure
              void this.setLoadingState(key, LoadingState.none);

              // Not handling the error, just cleanup.
              throw _context9.t0;
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[0, 11]]);
      }));
      function _updateChildren(_x12, _x13, _x14) {
        return _updateChildren3.apply(this, arguments);
      }
      return _updateChildren;
    }())
  }, {
    key: "getRootFolders",
    value: function () {
      var _getRootFolders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var roots;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.treeService.getRoots();
            case 2:
              roots = _context10.sent;
              void this.stores.parents.putAll(roots.map(function (root) {
                return [root, subRootKey];
              }));
              return _context10.abrupt("return", roots.reduce(function (map, root) {
                map.set(root.rootType, root);
                return map;
              }, new Map()));
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getRootFolders() {
        return _getRootFolders.apply(this, arguments);
      }
      return getRootFolders;
    }()
  }, {
    key: "getKnownAncestors",
    value: function () {
      var _getKnownAncestors = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(key) {
        var _this6 = this;
        var cached;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.stores.parents.get(key);
            case 2:
              cached = _context12.sent;
              if (!(cached.hasValue && cached.value.id === subRootId)) {
                _context12.next = 5;
                break;
              }
              return _context12.abrupt("return", [key]);
            case 5:
              return _context12.abrupt("return", cached.map(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(parent) {
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return _this6.getKnownAncestors(parent);
                      case 2:
                        return _context11.abrupt("return", _context11.sent.concat([key]));
                      case 3:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x16) {
                  return _ref3.apply(this, arguments);
                };
              }()).default([key]));
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getKnownAncestors(_x15) {
        return _getKnownAncestors.apply(this, arguments);
      }
      return getKnownAncestors;
    }()
  }, {
    key: "updatePages",
    value: function () {
      var _updatePages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(key, options) {
        var pageNumber,
          page,
          result,
          next,
          _args13 = arguments;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              pageNumber = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : 1;
              page = Page.fromPageNumber(pageNumber, defaultPageSize);
              _context13.next = 4;
              return this.updatePage(key, page, options.includeFiles, options.bundleId);
            case 4:
              result = _context13.sent;
              if (!result.hasMore) {
                _context13.next = 10;
                break;
              }
              _context13.next = 8;
              return this.updatePages(key, options, pageNumber + 1);
            case 8:
              next = _context13.sent;
              return _context13.abrupt("return", result.items.concat(next));
            case 10:
              return _context13.abrupt("return", result.items);
            case 11:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function updatePages(_x17, _x18) {
        return _updatePages.apply(this, arguments);
      }
      return updatePages;
    }()
  }, {
    key: "updatePage",
    value: function () {
      var _updatePage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(key, page, includeFiles, bundleId) {
        var _this7 = this;
        var itemPage, items;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.containerService.getChildren(key, new View(), page, includeFiles, false, false, true, bundleId);
            case 2:
              itemPage = _context14.sent;
              items = itemPage.items;
              _context14.next = 6;
              return this.updateItemStores(items, key);
            case 6:
              _context14.next = 8;
              return this.stores.children.update(key, function (cached) {
                return cached.map(function (known) {
                  return _this7.mergeItems(known, itemPage, includeFiles);
                }).orElse(items);
              });
            case 8:
              return _context14.abrupt("return", itemPage);
            case 9:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function updatePage(_x19, _x20, _x21, _x22) {
        return _updatePage.apply(this, arguments);
      }
      return updatePage;
    }()
    /**
     * I'm not 100% sure this is the right place to do this. I'd rather have a sort of update trigger
     * that runs every time children change and updates the flag, but this is the only such case so far.
     * If others arise we should consider a more comprehensive data consistency solution
     * @param key -
     */
  }, {
    key: "updateChildrenFlags",
    value: (function () {
      var _updateChildrenFlags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(key, includeFiles) {
        var children, _arrayPartition2, files, folders;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.stores.children.get(key);
            case 2:
              children = _context15.sent.default([]);
              _arrayPartition2 = arrayPartition(children, function (child) {
                return isContainerKey(child) ? 'folders' : 'files';
              }), files = _arrayPartition2.files, folders = _arrayPartition2.folders;
              _context15.next = 6;
              return this.stores.items.update(key, function (maybeContainer) {
                return maybeContainer.map(function (container) {
                  // If we're only updating folders, we shouldn't change the hasDocuments flag
                  var hasDocuments = includeFiles ? files.length > 0 : container.hasDocuments;
                  return _objectSpread(_objectSpread({}, container), {}, {
                    hasDocuments: hasDocuments,
                    hasFolders: folders.length > 0,
                    hasChildren: children.length > 0
                  });
                });
              });
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function updateChildrenFlags(_x23, _x24) {
        return _updateChildrenFlags.apply(this, arguments);
      }
      return updateChildrenFlags;
    }())
  }, {
    key: "mergeItems",
    value: function mergeItems(known, incoming, includeFiles) {
      // On the last page, drop anything that hasn't been found
      // page # may be greater than total because with no results
      // the api returns page 1 of 0
      var lastPage = !incoming.hasMore;
      if (!includeFiles) {
        var _arrayPartition3 = arrayPartition(known, function (key) {
            return isContainerKey(key) ? 'folders' : 'files';
          }),
          files = _arrayPartition3.files,
          folders = _arrayPartition3.folders;
        var mergedFolders = arrayMerge(folders, incoming.page.startIndex - 1, incoming.items, lastPage);

        // Luckily files always come after folders so we know this is correct
        return mergedFolders.concat(files);
      }

      // API numbers items from 1
      return arrayMerge(known, incoming.page.startIndex - 1, incoming.items, lastPage);
    }
  }, {
    key: "updateItemStores",
    value: function () {
      var _updateItemStores = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(items, container) {
        var parentsPromise, itemsPromise;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (container.type === ItemType.Client) {
                void this.stores.parents.put(container, subRootKey);
              }

              // Store parent relationship for found children
              parentsPromise = this.stores.parents.putAll(items.map(function (item) {
                return [item, container];
              })); // Store metadata for found children
              itemsPromise = this.stores.items.putAll(items.map(function (item) {
                return [item, item];
              })); // To avoid race conditions when consumers are notified, make sure
              // The database is populated with everything else first.
              _context16.next = 5;
              return Promise.all([parentsPromise, itemsPromise]);
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function updateItemStores(_x25, _x26) {
        return _updateItemStores.apply(this, arguments);
      }
      return updateItemStores;
    }()
    /**
     * Returns an observable for a tree starting at `key`
     * which does *not* include the key item itself.
     *
     * @param key -
     * @param includeFiles -
     */
  }, {
    key: "observeTreeRoot",
    value: function observeTreeRoot(key, options) {
      var childNodes$ = this.observeChildNodes(key, options);
      var loadingState$ = this.observeLoadingState(key);

      // This is potentially tricky - combineLatest won't emit anything until every given observable
      // has emitted something. That's why we prime childNodes$ with an empty array (see `observeChildKeys`)
      return combineLatest([childNodes$, loadingState$]).pipe(rxMap(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          childNodes = _ref5[0],
          loadingState = _ref5[1];
        return new TreeRoot(childNodes, loadingState);
      }));
    }

    /**
     * Returns an observable for a tree starting at `key`
     * which *does* include the key item itself.
     * (Recursively calls observeTreeRoot, then adds the item)
     *
     * @param key -
     * @param includeFiles -
     */
  }, {
    key: "observeTreeNode",
    value: function observeTreeNode(key, options) {
      var _this8 = this;
      return this.observeMaybeItem(key, options).pipe(maybeSwitchMap(function (item) {
        if (isContainerKey(key)) {
          return _this8.observeTreeRoot(key, options).pipe(rxMap(function (root) {
            return new TreeNode(item, root.children, root.state);
          }));
        }
        return new TreeNode(item);
      }));
    }

    /**
     * Returns an observable for the Tree Nodes of the children of `key`
     *
     * @param key -
     * @param includeFiles -
     */
  }, {
    key: "observeChildNodes",
    value: function observeChildNodes(key, options) {
      var _this9 = this;
      var keys$ = this.observeChildrenKeys(key, options.includeFiles, options.includeFolders);
      return keys$.pipe(switchMap(function (childKeys) {
        return _this9.observeNodes(childKeys, options);
      }), rxMap(function (childNodes) {
        return options.grouping ? _this9.groupNodes(childNodes, options.grouping, key) : childNodes;
      }));
    }
  }, {
    key: "groupNodes",
    value: function groupNodes(nodes, grouping, parent) {
      var _this10 = this;
      if (!isGroup(grouping.groupBy)) {
        return nodes;
      }
      var primary = firstGroupBy[grouping.groupBy];
      var groups = arrayPartition(nodes, function (node) {
        return String(getGroupId(primary, node.item));
      });
      var groupArray = Object.entries(groups).filter(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
          id = _ref7[0];
        return id !== NO_GROUP;
      });
      var grouped = groupArray.map(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          groupIdString = _ref9[0],
          projects = _ref9[1];
        var groupId = stringToGroupId(groupIdString, primary);
        var childGrouping = {
          groupBy: grouping.groupBy,
          groupId: groupId
        };
        var locked = projects.some(function (project) {
          return project.item.lock;
        });
        var virtualFolder = groupingToContainer(primary, childGrouping, parent, locked);
        var secondary = nextGrouping(grouping);
        var subGroupNodes = _this10.groupNodes(projects, secondary, virtualFolder);
        return new TreeNode(virtualFolder, subGroupNodes, LoadingState.loaded);
      });
      var unGrouped = groups[NO_GROUP] || [];
      return [].concat(_toConsumableArray(grouped), _toConsumableArray(unGrouped));
    }

    /**
     * Given an array of keys, returns an observable for a Tree Node for each key
     *
     * @param keys -
     * @param includeFiles -
     */
  }, {
    key: "observeNodes",
    value: function observeNodes(keys, options) {
      var _this11 = this;
      var filtered = keys.filter(function (k) {
        return options.includeFiles ? true : isContainerKey(k);
      });
      // combineLatest does not behave as expected with empty arrays, so shortcut here
      if (!filtered.length) {
        return rxOf([]);
      }
      var maybeNodes$ = keys.map(function (k) {
        return _this11.observeTreeNode(k, options);
      });
      // Remove the nodes that are missing items, as they won't be shown
      return combineLatest(maybeNodes$).pipe(rxMap(function (nodes) {
        return Maybe.filter(nodes);
      }));
    }

    /**
     * Returns an observable that may or may not contain an item,
     * depending on if that item has been loaded in cache or not
     * and if that item, once known, satisfies the given filter options.
     *
     * @param key -
     */
  }, {
    key: "observeMaybeItem",
    value: function observeMaybeItem(key, options) {
      var filter = itemFilter(options);
      var maybeItem$ = this.stores.items.observe(key).pipe(rxMap(function (item) {
        return Maybe.if(item, filter(item));
      }));

      // We need this observable to emit something - anything - immediately,
      // or combineLatest (used in `observeTreeRoot`) will hold up until the *entire*
      // tree is loaded into memory.
      // So we prime the observable (using concat) with either the item from cache, or a Maybe.nothing
      var initial$ = rxFrom(this.stores.items.get(key));
      return concat(initial$, maybeItem$);
    }
  }]);
}(StoreService);
export { TreeStore as default };
